import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { CookieAcceptanceService } from '../../service/cookie-acceptance.service';
import { CookieCategory } from '../../api/cookie-category';
import { CookieCategories } from '../../models/cookie-categories';
import { MatIconModule } from '@angular/material/icon';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
    selector: '.front-cookie-popup-details',
    imports: [
        MatIconModule,
        ReactiveFormsModule
    ],
    templateUrl: './cookie-popup-details.component.html',
    styleUrl: './cookie-popup-details.component.scss',
    animations: [
        trigger('open', [
            state('in', style({
                height: '*',
            })),
            state('out', style({
                height: '0px',
            })),
            transition('in <=> out', [
                animate('0.15s')
            ])
        ])
    ]
})
export class CookiePopupDetailsComponent implements OnDestroy {
    public readonly cookieCategories: CookieCategory[] = CookieCategories;

    public isActive: boolean = false;
    public expandedCategoryIndex: number | null = null;
    public cookieForm: FormGroup = new FormGroup({});;

    private cookieAcceptanceSubscription?: Subscription;

    public constructor(
        private readonly cookieAcceptanceService: CookieAcceptanceService
    ) {
        this.cookieAcceptanceSubscription = this.cookieAcceptanceService.isCookieDetailsPopupVisible.subscribe((isVisible: boolean) => {
            this.isActive = isVisible;
        });

        this.cookieCategories.forEach((category: CookieCategory) => {
            this.cookieForm.addControl(category.setting, new FormControl(category.isRequired, Validators.required));

            if (category.isRequired) {
                this.cookieForm.get(category.setting)?.disable();
            }
        });
    }

    public ngOnDestroy(): void {
        if (this.cookieAcceptanceSubscription) {
            this.cookieAcceptanceSubscription.unsubscribe();
        }
    }

    public toggleCategory(index: number): void {
        this.expandedCategoryIndex = this.expandedCategoryIndex === index ? null : index;
    }

    public acceptSelected(): void {
        this.cookieAcceptanceService.setCookieSetting(this.cookieForm.value);
        this.cookieAcceptanceService.isCookieDetailsPopupVisible.next(false);
    }

    public declineAllCookies(): void {
        this.cookieAcceptanceService.declineAllCookieSettings();
        this.cookieAcceptanceService.isCookieDetailsPopupVisible.next(false);
    }

    public acceptAllCookies(): void {
        this.cookieAcceptanceService.setAllCookieSettings();
        this.cookieAcceptanceService.isCookieDetailsPopupVisible.next(false);
    }
}
